import React from "react";
import { useSuppressionList } from "./SuppressionList.hooks";

const SuppressionListContext = React.createContext<ReturnType<
  typeof useSuppressionList
> | null>(null);

export function useSuppressionListView() {
  const contextValue = React.useContext(SuppressionListContext);
  if (!contextValue) {
    throw Error("Should be used inside the SuppressionListProvider");
  }
  return contextValue;
}

export const SuppressionListProvider = SuppressionListContext.Provider;
